<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container"
             :style="{ 'width': width, 'height': height, 'overflow-y':overflowY }"
        >
          <div v-if="hasCancelListener" @click="close" :class="'close-button ' + theme">
          </div>
          <div :class="'modal-header ' + theme">
            <slot name="header">
              Modal header
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body" />
          </div>

          <div class="modal-footer" v-if="$slots.footer">
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>

export default {
  name: 'Modal',
  props: {
    width: {
      type: String,
      required: false,
      default: '921px'
    },
    height: {
      type: String,
      required: false,
      default: 'auto'
    },
    overflowY: {
      type: String,
      required: false,
      default: 'auto'
    },
    theme: {
      type: String,
      required: false,
      default: 'primary'
    }
  },
  mounted() {
    document.body.classList.toggle('noscroll', true)
  },
  beforeDestroy() {
    document.body.classList.remove('noscroll', true)
  },
  computed: {
    hasCancelListener() {
      return this.$listeners && this.$listeners.close
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.modal-mask {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: flex;
  flex-direction: column;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-container {
  margin: auto auto;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  overflow-y: hidden;
  overflow-x: hidden;
  height: auto;

  @media (max-width: $header-change) {
    width: 100% !important;
    max-width: none;
    height: 100vh !important;
  }
}

.modal-header {
  padding: 15px 0 15px 57px;
  font-family: OpenSans-Bold, sans-serif;
  font-size: 20px;
  color: #FFFFFF;
  letter-spacing: 0;
  text-align: center;
  line-height: 30px;

  &.primary {
    background-image: url('~@/assets/ModalBackgroundImage.png');
    background-size: cover;
  }

  &.light {
    color: $black-color;
    font-weight: 600;
    border-bottom: 1px solid #D8D8D8;
  }
}

.close-button {
  float: right;
  margin: 18px 18px 0;
  color: white;
  cursor: pointer;
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;

  &.primary {
    background-image: url('~@/assets/CloseWhite.svg');
  }

  &.light {
    background-image: url('~@/assets/CloseMed.svg');
  }
}

.modal-body {
  margin: 0 0;
  display: flex;
  flex-direction: column;
  cursor: default;
  width: 100%;
}

.modal-footer {
  box-shadow: inset 0 1px 0 0 #D8D8D8;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  width: 100%;
  box-sizing: border-box;
  padding: 10px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
